/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Success_Create_DescInputs */

const es_feedback_modal_success_create_desc = /** @type {(inputs: Feedback_Modal_Success_Create_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gracias por ayudarnos a mejorar.`)
};

const en_feedback_modal_success_create_desc = /** @type {(inputs: Feedback_Modal_Success_Create_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for helping us improve.`)
};

/**
* | output |
* | --- |
* | "Thank you for helping us improve." |
*
* @param {Feedback_Modal_Success_Create_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_success_create_desc = /** @type {((inputs?: Feedback_Modal_Success_Create_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Success_Create_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_success_create_desc(inputs)
	return en_feedback_modal_success_create_desc(inputs)
});
export { feedback_modal_success_create_desc as "feedback.modal.success_create_desc" }